/* Accessible desktop mega-menu disclosure. No storage, network or commerce actions. */
(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('.gcf-menu-toggle:not([data-gcf-ready])').forEach(button => {
      button.dataset.gcfReady = 'true';
      const item = button.closest('.list-menu--megamenu');
      const menu = item?.querySelector('.header__mega-menu');
      if (!item || !menu) return;
      let pinned = false;

      const setOpen = open => {
        if (open) {
          document.querySelectorAll('.gcf-menu-toggle[aria-expanded="true"]').forEach(other => {
            if (other !== button) other.dispatchEvent(new Event('galrie:close-menu'));
          });
        }
        menu.hidden = !open;
        item.classList.toggle('gcf-menu-open', open);
        item.classList.toggle('list-menu--megamenu-visible', open);
        button.setAttribute('aria-expanded', String(open));
      };

      button.addEventListener('galrie:close-menu', () => { pinned = false; setOpen(false); });
      button.addEventListener('click', event => {
        event.preventDefault();
        pinned = !pinned;
        setOpen(pinned);
      });
      item.addEventListener('mouseenter', () => setOpen(true));
      item.addEventListener('mouseleave', () => {
        if (!item.contains(document.activeElement)) {
          pinned = false;
          setOpen(false);
        }
      });
      item.addEventListener('focusout', event => {
        if (!item.contains(event.relatedTarget)) {
          pinned = false;
          setOpen(false);
        }
      });
      item.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        pinned = false;
        setOpen(false);
        button.focus();
      });
      document.addEventListener('click', event => {
        if (!item.contains(event.target)) {
          pinned = false;
          setOpen(false);
        }
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();

/* Native inline disclosures inside the existing, focus-trapped mobile drawer. */
(() => {
  function initialise(root = document) {
    root.querySelectorAll('header-drawer').forEach(drawer => {
      if (drawer.dataset.gcfBrowseReady) return;
      drawer.dataset.gcfBrowseReady = 'true';
      const main = drawer.querySelector('details');
      // Capture stops only this component reaching the legacy sliding-submenu handler.
      drawer.addEventListener('click', event => {
        const summary = event.target.closest('summary');
        if (!summary?.parentElement.matches('.gcf-browse-mobile, .gcf-browse-disclosure')) return;
        event.stopImmediatePropagation();
      }, true);
      drawer.querySelectorAll('.gcf-browse-mobile, .gcf-browse-disclosure').forEach(details => {
        details.addEventListener('toggle', () => {
          const summary = details.querySelector(':scope > summary');
          summary.setAttribute('aria-expanded', String(details.open));
          if (main.open && typeof trapFocus === 'function') trapFocus(main, summary);
        });
      });
      let escapeHandled = false;
      drawer.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('.gcf-browse-disclosure[open], .gcf-browse-mobile[open]');
        if (!main.open) return;
        // Handle before the legacy header's search Escape listener can steal focus.
        escapeHandled = true;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (details) {
          details.open = false;
          details.querySelector(':scope > summary').focus();
        } else {
          drawer.closeMenuDrawer(event, main.querySelector('summary'));
        }
      }, true);
      drawer.addEventListener('keyup', event => {
        if (event.key === 'Escape' && escapeHandled) {
          event.stopImmediatePropagation();
          escapeHandled = false;
        }
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
